// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"6bbb6887","145":"009e973d","188":"07163058","190":"8503fb9f","378":"95d6097f","401":"38e045f8","609":"847a1988","854":"62a2c4a7","859":"95423862","870":"348db05d"}[chunkId] + ".chunk.js";
};